import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../../modules/billing/vendorBill';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state, ownProps) => {

	/** @namespace state.lists.vendorBillIds **/
	/** @namespace state.maps.vendorBill **/
	/** @namespace state.maps.user **/
	let pendingVendorBills = undefined;
	let completedVendorBills  = undefined;
	if (state.vendorBills.byStatus) {
		const { pending, completed } = state.vendorBills.byStatus;
		if (pending) {
			pendingVendorBills = _.map(pending, id => state.maps.vendorBill[id]);
		}
		if (completed) {
			completedVendorBills = _.map(completed, id => state.maps.vendorBill[id]);
		}
	}

	let vendorBill;
	let vendorBillId;

	if (ownProps.vendorBill) {
		vendorBill = ownProps.vendorBill;
		vendorBillId = vendorBill.vendorBillId;
	} else {
		vendorBillId = (ownProps.vendorBillId)
			? ownProps.vendorBillId
			: _.get(ownProps, ['match', 'params', 'vendorBillId']);
		vendorBill = _.get(state.maps, ['vendorBill', vendorBillId]);
	}

	let vendorBillLogs = [];
	/** @namespace state.lists.vendorBillLogIds **/
	/** @namespace state.lists.vendorBillLog **/

	if (
		state.lists.vendorBillLogIds &&
		state.lists.vendorBillLogIds[vendorBillId]
	) {
		vendorBillLogs = _.map(state.lists.vendorBillLogIds[vendorBillId],
			id => state.maps.vendorBillLog[id]
		);
	}

	const canMakeUpdates = !!(_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false));
	return {
		vendorBill,
		vendorBillLogs,
		pendingVendorBills,
		completedVendorBills,
		userMap : state.maps.user,
		bulkCustomerMap : state.maps.bulkCustomer,

		supplierMap : state.maps.supplier,
		carrierMap : state.maps.carrier,
		resourceMap : state.maps.resource,
		canMakeUpdates,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchVendorBills : search,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
